const color = {
    blue: '#804c85',
    indigo: '#405189',
    purple: '#8561f9',
    pink: '#f7649f',
    red: '#ff6c6c',
    orange: '#f1963b',
    yellow: '#f6b749',
    green: '#2dcb73',
    teal: '#4ab0c1',
    cyan: '#438eff',
    white: '#fff',
    black: '#000',
    grey: '#141821bf'
};

const white = {
    50: '#ffffff80',
    75: '#ffffffbf'
}

export const grey = {
    50: '#fafafa',
    100: '#f3f6f9',
    200: '#eff2f7',
    300: '#e9ebec',
    400: '#ced4da',
    500: '#adb5bd', 
    600: '#878a99',
    700: '#2b313e',
    800: '#1f242e',
    900: '#141821'
};

const palette = (mode: any) => ({
    mode,
    ...(mode === 'light'
        ? {
            default: {
                main: color.white
            },
            primary: {
                light: "#438eff1a",
                main: color.cyan,
                dark: "#106fff"
            },
            inherit: {
                main: color.grey
            },
            inherit200: {
                main: grey[200]
            },
            pricebg: {
                main: grey[200]
            },
            textDark: {
                main: "#000"
            },
            secondary: {
                main: color.purple
            },
            success: {
                main: color.green
            },
            revenueBg: {
                light: '#f9fbfc'
            },
            info: {
                main: color.teal,
                light: '#eff2f7'
            },
            warning: {
                main: color.yellow
            },
            danger: {
                main: color.red
            },
            error: {
                main: color.red
            },
            light: {
                main: grey[200]
            },
            dark: {
                main: grey[900]
            },
            white: {
                main: color.white
            },
            white50: {
                main: white[50]
            },
            white75: {
                main: white[75]
            },
            successBgSubtle: {
                main: '#d5f5e3'
            },
            secondaryBgSubtle: {
                main: '#8561f91a'
            },
            infoBgSubtle: {
                main: '#dbeff3'
            },
            warningBgSubtle: {
                main: '#fdf1db'
            },
            primaryBgSubtle: {
                main: '#ecf3ff',
            },
            dangerBgSubtle: {
                main: '#ffe2e2'
            },
            darkbtnbg: {
                main: '#1418211a'
            },
            dangerbtnbg: {
                main: '#ff6c6c1a'
            },
            dangerbagdebg: {
                main: '#ff6c6c'
            },
            primarybtnbg: {
                main: '#438eff1a'
            },
            infobtnbg: {
                main: '#4ab0c11a'
            },
            bodytheme: {
                main: '#fff'
            },
            cardbg: {
                main: '#fff'
            },
            dropdownbg: {
                main: '#fff'
            },
            textmuted: {
                main: '#141821bf'
            },
            productbg: {
                main: '#eff2f7'
            },
            bordercolor: {
                main: 'gray'
            },
            bodycolor: {
                main: '#141821'
            },
            emphasiscolor: {
                main: "#000"
            },
            sidebar: {
                main: "#fff",
                title: "#919da9",
                link: "#6d7080",
                linkHover: '#438eff',
                linkHoverFill: "#d7e7ff",
            },
            textbody: {
                main: grey[900]
            },
            textlight: {
                main: '#eff2f7'
            },
            selectmenu: {
                main: '#fff'
            }
        }
        : {
            default: {
                main: color.white
            },
            primary: {
                light: "#438eff1a",
                main: color.cyan,
                dark: "#106fff"
            },
            inherit: {
                main: grey[50]
            },
            inherit200: {
                main: grey[200]
            },            
            pricebg: {
                main: '#2b313e'
            },
            textDark: {
                main: "#fff"
            },
            secondary: {
                main: color.purple
            },
            success: {
                main: color.green
            },
            revenueBg: {
                light: '#2b313e'
            },
            info: {
                main: color.teal,
                light: '#2b313e'
            },
            warning: {
                main: color.yellow
            },
            danger: {
                main: color.red
            },
            error: {
                main: color.red
            },
            light: {
                main: grey[200]
            },
            dark: {
                main: grey[900]
            },
            white: {
                main: color.white
            },
            white50: {
                main: white[50]
            },
            white75: {
                main: white[75]
            },
            successBgSubtle: {
                main: '#12512e'
            },
            secondaryBgSubtle: {
                main: '#8561f91a'
            },
            infoBgSubtle: {
                main: '#1e464d'
            },
            warningBgSubtle: {
                main: '#62491d'
            },
            primaryBgSubtle: {
                main: '#1b3966',
            },
            dangerBgSubtle: {
                main: '#662b2b'
            },
            darkbtnbg: {
                main: '#1418211a'
            },
            dangerbtnbg: {
                main: '#ff6c6c1a'
            },            
            dangerbagdebg: {
                main: '#ff6c6c'
            },
            primarybtnbg: {
                main: '#438eff1a'
            },
            infobtnbg: {
                main: '#4ab0c11a'
            },
            bodytheme: {
                main: '#2b313e'
            },
            cardbg: {
                main: grey[800]
            },
            dropdownbg: {
                main: grey[800]
            },
            textmuted: {
                main: '#adb5bd'
            },
            productbg: {
                main: '#eff2f7'
            },
            bordercolor: {
                main: 'red'
            },
            bodycolor: {
                main: '#adb5bd'
            },
            emphasiscolor: {
                main: "#878a99"
            },
            sidebar: {
                main: "#000",
                title: "#919da9",
                link: grey[500],
                linkHover: '#fff',
                linkHoverFill: "#d7e7ff",
            },
            textbody: {
                main: grey[500]
            },
            textlight: {
                main: '#2b313e'
            },            
            selectmenu: {
                main: '#020815'
            }
        }),
});

export default palette;